export const movieShowtimesTheaterLimits = {
  fullList: 50,
  preview: 5,
} as const;

export const theaterSearch = {
  gamescapeRadius: parseInt(process.env.NEXT_PUBLIC_GAMESCAPE_THEATER_SEARCH_RADIUS || '3000', 10),
  limit: parseInt(process.env.NEXT_PUBLIC_THEATER_SEARCH_RADIUS_RESULTS || '50', 10),
  radius: parseInt(process.env.NEXT_PUBLIC_THEATER_SEARCH_RADIUS || '50', 10),
} as const;
